import Cookies from 'js-cookie';

const mutations = {
  CREATE_SESSION(state, data) {
    state.sessionId = data.sessionId;
  },
  FLAGS_DATA(state, data) {
    state.flagsData = data.variantConfig;
    localStorage.setItem('flagsData', JSON.stringify(data.variantConfig));
  },
  FLAGS_ALL_DATA(state, data) {
    state.flagsAllData = data;
    localStorage.setItem('flagsAllData', JSON.stringify(data));
  },
  RE_KYC_DATA(state, data) {
    if (data?.customerKycRequired) {
      state.reKyc = data?.customerKycRequired;
      localStorage.setItem('re-kyc', JSON.stringify(data?.customerKycRequired));
    } else {
      state.reKyc = false;
      localStorage.removeItem('re-kyc');
    }
  },
  SAVE_TOKEN(state, data) {
    state.token = `${data.tokenType} ${data.accessToken}`;
    if (data?.isGuarantor) {
      state.isGuarantor = data?.isGuarantor;
      localStorage.setItem('isGuarantor', data?.isGuarantor);
    }
    localStorage.setItem('token', state.token);
    Cookies.set('authToken', state.token, { expires: 1, path: '/', secure: true, domain: '.epaylater.in' });
  },
  SAVE_PHONE(state, data) {
    state.phone = data;
    localStorage.setItem('phone', data);
    Cookies.set("mobileNo", data, { expires: 1, path: '/', secure: true, domain: '.epaylater.in' });
  },
  CLEAR_SESSION() {
    const url = new URL(window.location);
    const urlParams = localStorage.getItem("newUrl");
    const marketplaceName = localStorage.getItem('referralMarketplaceMcode');
    const callbackUrl = localStorage.getItem('referralCallbackUrl');

    if (callbackUrl) {
      url.searchParams.set('marketplaceName', marketplaceName);
      url.searchParams.set('callbackUrl', callbackUrl);
    }
    localStorage.clear();
    if (urlParams) {
      window.location = urlParams;
    } else {
      if (callbackUrl !== null) {
        window.location = callbackUrl;
      } else {
        window.location = url;
      }
    return;
    }
      // localhost
      Cookies.remove('mobileNo');
      Cookies.remove('authToken');
      // serverSite
      Cookies.remove('mobileNo', { path: '/', domain: '.epaylater.in' });
      Cookies.remove('authToken', { path: '/', domain: '.epaylater.in' });
  },
  SAVE_MARKETPLACE_INFO(state, data) {
    localStorage.setItem('marketplaceInfo', JSON.stringify(data));
    state.marketplaceInfo = data;
  },
  IS_SET_RE_KYC(state, data) {
    state.isSetReKyc = data;
    localStorage.setItem('isSetReKyc', data);
  },
  NOTIFICATION_LIST(state, data) {
    state.notificationList = data;
  },
  GUARANTOR_LOAN_ID(state, data) {
    state.guarantorLoanId = data;
    localStorage.setItem('guarantorLoanId', JSON.stringify(data));
  },
  GUARANTOR_DATA(state, data) {
    state.guarantorData = data;
    localStorage.setItem('guarantorData', JSON.stringify(data));
  }
};
export default mutations;
